<template>
  <div>
    <div
      v-if="localGuideOn"
      class="overlay"
      @click.self="!isLastStage && nextHint()"
    />
    <VPopup
      v-if="localGuideOn && currentStage"
      class="hint-popup"
      :class="{'guide-mode': guideMode}"
      :visible="localGuideOn"
      position="bottom"
      not-hide-on-click
    >
      <template #default>
        <div class="window-popup">
          <div class="content">
            <div class="content-header">
              <p class="content-header-title">
                {{ currentStage.title }}
              </p>
              <VButton
                theme="link"
                class="content-header-close"
                @click="hideHint"
              >
                <VIcon material="close" />
              </VButton>
            </div>
            <div class="content-wrap">
              <div class="content-stage">
                <p class="description">
                  {{ currentStage.description }}
                </p>

                <img
                  class="img"
                  alt="img"
									:src="currentStage.img"
                  @click="nextHint"
                >
              </div>
              <div class="stages-nav">
                <div class="stages-nav-title">
                  Навигация
                </div>
                <ul class="stages-list">
                  <li
                    v-for="(stage, index) in stages"
                    :key="index"
                    class="stage"
										:class="{ active: index === currentIndex }"
										@click="setCurrentStage(index)"
                  >
                    {{ stage.title }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div
          class="footer"
        >
          <VButton
            theme="link"
            class="back"
            :disabled="isFirstStage"
            @click="prevHint"
          >
            <template #icon>
              <VIcon
                class="arrow arrow-back"
                material="arrow_back"
              />
            </template>
          </VButton>

          <ul class="dots-container">
						<li
							v-for="(stage, index) in stages"
							:key="index"
							class="dot"
							:class="{ active: index === currentIndex }"
							@click="setCurrentStage(index)"
						/>
          </ul>

          <VButton
            theme="link"
            icon-postfix
            class="next"
            @click="nextHint"
          >
            <template #icon>
              <VIcon
                class="arrow arrow-next"
                :material="isLastStage ? 'close' : 'arrow_forward'"
              />
            </template>
          </VButton>
        </div>
      </template>
    </VPopup>
  </div>
</template>

<style lang="scss" src="./TenderGuidePopup.scss"/>

<script lang="ts">
import Core            from "@/core/Core";
import { buyerStages, sellerStages } from '@/domains/Tenders/components/TenderGuidePopup/TenderGuideStages';

export default defineComponent({
	name: 'TenderGuidePopup',

	props: {
		guideOn: {
			type:    Boolean,
			default: false,
		},
		storageKey: {
			type:    String,
			default: null,
		},
		isTendersPage: {
			type:    Boolean,
			default: false,
		},
		isEditDialog: {
			type:    Boolean,
			default: false,
		},
	},
	data() {
		return {
			currentIndex: 0,
			localGuideOn: this.guideOn,
		};
	},

	computed: {
    stages() {
      if (Core.currentPartner.isBuyer) {
        return buyerStages;
      }
      return sellerStages;
    },
		guideMode() {
			return this.localGuideOn;
		},
		currentStage() {
			return this.stages[this.currentIndex];
		},
		isFirstStage() {
			return this.currentIndex === 0;
		},
		isLastStage() {
			return this.currentIndex === this.stages.length - 1;
		},
	},

	watch: {
		guideOn: {
			handler(newVal) {
				this.localGuideOn = newVal;

				/** stages теперь импортируются, а не передаются в пропсах */
				if (newVal && this.stages.length > 0) {
					this.currentIndex = 0;
					window.addEventListener('keydown', this.handleKeyDown);
				} else {
					window.removeEventListener('keydown', this.handleKeyDown);
				}
			},
			immediate: true,
		},
	},

	mounted() {
		if (this.storageKey && JSON.parse(localStorage.getItem(this.storageKey)) === false) return

		/** предзагрузка скринов */
		this.preloadImages();
	},

	beforeUnmount() {
		window.removeEventListener('keydown', this.handleKeyDown);
	},


	methods: {
		/** предзагрузка скринов при маунте компонента */
		preloadImages() {
			this.stages.forEach(stage => {
				const img = new Image();
				img.src   = stage.img;
			});
		},

		handleKeyDown(event) {
			if (!this.localGuideOn) return;

			if (['ArrowLeft', 'ArrowUp'].includes(event.key)) this.prevHint();
			if (['ArrowRight', 'ArrowDown'].includes(event.key)) this.nextHint();
			if (event.key === 'Escape') this.hideHint();
		},

		nextHint() {
			if (this.isLastStage) {
				this.hideHint();
				return;
			}
			this.currentIndex++;
		},

		prevHint() {
			if (this.currentIndex > 0) {
				this.currentIndex--;
			}
		},

		setCurrentStage(index) {
			this.currentIndex = index;
		},

		hideHint() {
			this.localGuideOn = false;
			if (this.storageKey) localStorage.setItem(this.storageKey, JSON.stringify(false));
			this.$emit('update:guideOn', false);
			this.$emit('close');
		},
	},
});
</script>
